module.exports = __webpack_public_path__ + "img/om.09e65f8.svg";